import { collection, onSnapshot } from 'firebase/firestore';
import { InventoryAuthority, inventoryFirestorePath } from '@qkindex/contracts';
import { Location } from '../domain/location';
import { db } from '../firebase';
import { DocumentLike, mapLocationDocument } from './mappers';

interface SnapshotLike {
  docs: DocumentLike[];
}
type Listen = (
  next: (snapshot: SnapshotLike) => void,
  error: (error: Error) => void,
) => () => void;

export const createLocationSubscriber =
  (listen: Listen) =>
  (
    onLocations: (locations: Location[]) => void,
    onError: (error: Error) => void,
  ): (() => void) =>
    listen(
      (snapshot) =>
        onLocations(
          snapshot.docs
            .map(mapLocationDocument)
            .filter((location): location is Location => location !== null),
        ),
      onError,
    );

export const subscribeToLocations = (
  authority: InventoryAuthority,
  onLocations: (locations: Location[]) => void,
  onError: (error: Error) => void,
): (() => void) =>
  createLocationSubscriber((next, error) =>
    onSnapshot(
      collection(db, inventoryFirestorePath(authority, 'locations')),
      next,
      error,
    ),
  )(onLocations, onError);
